<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{data.sysText.editLeaveAdminInfo_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="multi-select-container">
      <mat-icon [ngClass]="{ focus: select.focused }">list</mat-icon>
      <mat-form-field color="accent">
        <mat-label>{{ data.sysText.dashboardAdditionalDetails_Title }}</mat-label>
        <mat-select #select="matSelect" [formControl]="form.controls.dashboardAdditionalFields" multiple disableOptionCentering panelClass="dropDownSelectMultiple" panelWidth="fit-content">
          @for (option of additionalDetailOptions; track option) {
            <mat-option [value]="option.id">
              <span>{{ option.description }}</span>
            </mat-option>
          }
        </mat-select>
        <!-- mat hint for spacing -->
        <mat-hint></mat-hint>
        <mat-error>{{ form.controls.dashboardAdditionalFields.errors?.msError }}</mat-error>
      </mat-form-field>
      <!-- buttons so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.dashboardAdditionalDetails_Info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>

    <div class="toggle-title">
      <mat-icon>date_range</mat-icon>
      <p class="grey1">{{ data.sysText.allowNewRequests_Title }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.allowNewRequests_Info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowAnonymousRequests"
        [label]="data.sysText.allowAnonymousRequests_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowCompanyRepSubmitNewRequest"
        [label]="data.sysText.allowCompanyRepNewRequests_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowSupvSubmitNewRequest"
        [label]="data.sysText.allowSupvNewRequests_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>

    <div class="toggle-title">
      <mat-icon>upload</mat-icon>
      <p class="grey1">{{ data.sysText.allowUploadDoc_Title | titlecase }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.allowUploadDoc_Info | capitalizefirst"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowCompanyRepUploadDoc"
        [label]="data.sysText.allowCompanyRepUploadDoc_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowSupvUploadDoc"
        [label]="data.sysText.allowSupvUploadDoc_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>

    <div class="toggle-title">
      <mat-icon>update</mat-icon>
      <p class="grey1">{{ data.sysText.allowSubmitIntermittentTime_Title | titlecase }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.allowSubmitIntermittentTime_Info | capitalizefirst"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowSubmitIntermittentTime"
        [label]="data.sysText.allowSubmitIntermittentTime_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowCompanyRepSubmitIntermittentTime"
        [label]="data.sysText.allowCompanyRepSubmitIntermittentTime_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowSupvSubmitIntermittentTime"
        [label]="data.sysText.allowSupvSubmitIntermittentTime_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <app-text-area
      [control]="form.controls.submitIntermittentTimeComments"
      [label]="data.sysText.allowSubmitIntermittentTime_Comments_Title"
      [ariaLabel]="data.sysText.allowSubmitIntermittentTime_Title + ' ' + data.sysText.allowSubmitIntermittentTime_Comments_Title"
      [msErrorKey]="'submitIntermittentTimeComments'"
      [info]="data.sysText.allowSubmitIntermittentTime_Comments_Info | capitalizefirst">
    </app-text-area>

    <div class="toggle-title">
      <mat-icon>update</mat-icon>
      <p class="grey1">{{ data.sysText.allowLeaveHoursRequests_Title }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.allowLeaveHoursRequests_Info | capitalizefirst"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowLeaveHoursRequest"
        [label]="data.sysText.leaveHoursRequestsEnabled"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowAnonymousLeaveHoursRequest"
        [label]="data.sysText.leaveHoursRequestsWithoutLoginEnabled"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowEmployeeLeaveHoursRequest"
        [label]="data.sysText.leaveHoursRequestsEnabledForEmployees"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowCompanyRepLeaveHoursRequest"
        [label]="data.sysText.leaveHoursRequestsEnabledForCompanyReps"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.allowSupvLeaveHoursRequest"
        [label]="data.sysText.leaveHoursRequestsEnabledForSupvs"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>

    <div class="toggle-title">
      <mat-icon>update</mat-icon>
      <p class="grey1">{{ data.sysText.restrictHours_Title }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.restrictHours_Info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.restrictHoursToWorkdays"
        [label]="data.sysText.restrictHoursToWorkdays_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
    <div class="toggle-container">
      <app-slide-toggle
        [control]="this.form.controls.restrictHoursToWorkdayHours"
        [label]="data.sysText.restrictHoursToWorkdayHours_Toggle"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>

    <div class="toggle-title">
      <mat-icon>update</mat-icon>
      <p class="grey1">{{ data.sysText.hoursCalculations_Title }}</p>
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="data.sysText.moreInformation_ariaLabel"
        [matTooltip]="data.sysText.hoursCalculations_Info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <app-select-field
      [control]="form.controls.autoUseHoursWorked"
      [label]="data.sysText.autoUseHoursWorked"
      [options]="yesNoOptions"
      [showBlankOption]="true"
      [shouldCapitalize]="false"
      [hint]="autoUseHoursWorkedHint"
      [isHintHighlighted]="false"
      [info]="data.sysText.autoUseHoursWorked_info">
    </app-select-field>

    <app-select-field
      [control]="form.controls.leaveDocFreq"
      [label]="data.sysText.leaveDocFreq_Title"
      [options]="data.employerLeaveDialogInfo.leaveDocFreqOptions"
      [showBlankOption]="true"
      [icon]="'sync'"
      [shouldCapitalize]="false"
      [customMsError]="(data.employerProfile.modelStateErrors.hasOwnProperty('leaveDocFreq') ? ((data.sysText.leaveDocFreq_Title | titlecase) + ' ' + data.sysText.required) : null)"
      [msErrorKey]="'leaveDocFreq'"
      [info]="data.sysText.leaveDocFreq_Info | capitalizefirst">
    </app-select-field>
    <app-select-field
      [control]="form.controls.dataCollectionMethod"
      [label]="data.sysText.dataCollectionMethod_Title"
      [options]="data.employerLeaveDialogInfo.dataCollectionMethodOptions"
      [showBlankOption]="true"
      [icon]="'create_new_folder'"
      [shouldCapitalize]="false"
      [customMsError]="(data.employerProfile.modelStateErrors.hasOwnProperty('dataCollectionMethod') ? ((data.sysText.dataCollectionMethod_Title | titlecase) + ' ' + data.sysText.required) : null)"
      [msErrorKey]="'dataCollectionMethod'"
      [info]="data.sysText.dataCollectionMethod_Info | capitalizefirst">
    </app-select-field>
    <app-text-area
      [control]="form.controls.dataCollectionMethodComments"
      [label]="data.sysText.comments"
      [ariaLabel]="data.sysText.dataCollectionMethod_Title + ' ' + data.sysText.comments"
      [msErrorKey]="'dataCollectionMethodComments'"
      [info]="data.sysText.dataCollectionMethod_Comments_Info | capitalizefirst">
    </app-text-area>
    <app-radio-button-group
      [control]="form.controls.commPref"
      [label]="data.sysText.commPref_Title"
      [icon]="'question_answer'"
      [isStacked]="true"
      [isYesNo]="true"
      [customYes]="data.sysText.commPref_Yes | capitalizefirst"
      [customNo]="data.sysText.commPref_No | capitalizefirst"
      [info]="data.sysText.commPref_Info | capitalizefirst">
    </app-radio-button-group>
    <app-select-field
      [control]="form.controls.benefitPremiums"
      [label]="data.sysText.benefitPremiums_Title"
      [options]="data.employerLeaveDialogInfo.benefitPremiumsOptions"
      [showBlankOption]="true"
      [icon]="'paid'"
      [shouldCapitalize]="false"
      [customMsError]="(data.employerProfile.modelStateErrors.hasOwnProperty('benefitPremiums') ? ((data.sysText.benefitPremiums_Title | titlecase) + ' ' + data.sysText.required) : null)"
      [msErrorKey]="'benefitPremiums'"
      [info]="data.sysText.benefitPremiums_Info | capitalizefirst">
    </app-select-field>
    <app-text-area
      [control]="form.controls.benefitPremiumsComments"
      [label]="data.sysText.comments"
      [ariaLabel]="data.sysText.benefitPremiums_Title + ' ' + data.sysText.comments"
      [msErrorKey]="'benefitPremiumsComments'"
      [info]="data.sysText.benefitPremiums_Comments_Info | capitalizefirst">
    </app-text-area>
    <app-text-area
      [control]="form.controls.loaApproval"
      [label]="data.sysText.loaApproval_Title"
      [hint]="data.sysText.loaApproval_Hint"
      [isHintHighlighted]="false"
      [icon]="'checklist'"
      [shouldCapitalizeLabel]="false"
      [customMsError]="(data.employerProfile.modelStateErrors.hasOwnProperty('loaApproval') ? ((data.sysText.loaApproval_Title) + ' ' + data.sysText.required) : null)"
      [msErrorKey]="'loaApproval'"
      [info]="data.sysText.loaApproval_Info | capitalizefirst">
    </app-text-area>
    <app-radio-button-group
      [control]="form.controls.ptoSickTime"
      [label]="data.sysText.ptoSickTime_Title"
      [shouldCapitalizeLabel]="false"
      [icon]="'medical_services'"
      [isStacked]="true"
      [isYesNo]="true"
      [info]="data.sysText.ptoSickTime_Info">
    </app-radio-button-group>
    <app-text-area
      [control]="form.controls.ptoSickTimeComments"
      [label]="data.sysText.comments"
      [ariaLabel]="data.sysText.ptoSickTime_Title + ' ' + data.sysText.comments"
      [msErrorKey]="'ptoSickTimeComments'"
      [info]="data.sysText.ptoSickTime_Comments_Info | capitalizefirst">
    </app-text-area>
    <app-radio-button-group
      [control]="form.controls.shortTermDisability"
      [label]="data.sysText.shortTermDisability_Title"
      [shouldCapitalizeLabel]="false"
      [icon]="'accessible'"
      [isStacked]="true"
      [isYesNo]="true"
      [info]="data.sysText.shortTermDisability_Info">
    </app-radio-button-group>
    <app-text-area
      [control]="form.controls.shortTermDisabilityComments"
      [label]="data.sysText.comments"
      [ariaLabel]="data.sysText.shortTermDisability_Title + ' ' + data.sysText.comments"
      [msErrorKey]="'shortTermDisabilityComments'"
      [info]="data.sysText.shortTermDisability_Comments_Info | capitalizefirst">
    </app-text-area>
    <app-text-area
      [control]="form.controls.verifyReturnToWork"
      [label]="data.sysText.verifyReturnToWork_Title"
      [icon]="'task'"
      [customMsError]="(data.employerProfile.modelStateErrors.hasOwnProperty('verifyReturnToWork') ? ((data.sysText.verifyReturnToWork_Title | titlecase) + ' ' + data.sysText.required) : null)"
      [msErrorKey]="'verifyReturnToWork'"
      [info]="data.sysText.verifyReturnToWork_Info | capitalizefirst">
    </app-text-area>
    <app-radio-button-group
      [control]="form.controls.requireImportedCaseVerification"
      [label]="data.sysText.requireImportedCaseVerification_Title"
      [icon]="'task'"
      [isStacked]="true"
      [isYesNo]="true"
      [info]="data.sysText.requireImportedCaseVerification_Info">
    </app-radio-button-group>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>